<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="Value Setting LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:;"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
    </table-view>

    <!-- 新增/编辑弹窗   -->
    <el-dialog
      :visible.sync="visible"
      :title="isEdit ? 'Edit' : 'Add'"
      width="462px"
      @close="handleClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="Parent Node" prop="firstId">
            <el-select
              v-model="form.firstId"
              style="width: 100%"
              @change="handleNodeChange"
              :clearable="true"
            >
              <el-option
                v-for="item in optionList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Parent Node Name" prop="pid">
            <el-select v-model="form.pid" style="width: 100%" :clearable="true">
              <el-option
                v-for="item in optionNameList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Parameter Name" prop="typeId">
            <el-select
              v-model="form.typeId"
              style="width: 100%"
              @change="handleTypeChange"
            >
              <el-option
                v-for="item in optionList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Value Name" prop="name">
            <el-input style="width: 100%" v-model="form.name" />
          </el-form-item>
          <el-form-item
            v-if="isShowShore"
            label="Onshore/Offshore"
            prop="onOffshore"
          >
            <el-select v-model="form.onOffshore" style="width: 100%">
              <el-option label="Onshore" :value="1" />
              <el-option label="Offshore" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="Value Identification" prop="mark">
            <el-input style="width: 100%" v-model="form.mark" />
          </el-form-item>
          <el-form-item label="Value Sort" prop="num">
            <el-input style="width: 100%" v-model="form.num" />
          </el-form-item>
          <el-form-item label="Source" prop="source">
            <el-select v-model="form.source" style="width: 100%">
              <el-option label="Trade" :value="1" />
              <el-option label="CSS" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="Status" prop="status">
            <el-select v-model="form.status" style="width: 100%">
              <el-option label="Active" :value="1" />
              <el-option label="Inactive" :value="2" />
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSave">
          Save
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, updateOrAdd, getOptionList, removeItem } from './api'
import { getSelectList } from '@/api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Parameter Name',
        type: 'select',
        key: 'typeId',
        selectList: [],
        defaultValue: '',
      },
      {
        label: 'Source',
        type: 'select',
        placeholder: 'All',
        key: 'source',
        selectList: [
          {
            name: 'Trade',
            id: 1,
          },
          {
            name: 'CSS',
            id: 2,
          },
        ],
      },
    ]
    const tableModel = [
      {
        label: 'Parameter Name',
        prop: 'typeName',
      },
      {
        label: 'Value Name',
        prop: 'name',
      },
      {
        label: 'Value Identification',
        prop: 'mark',
      },
      {
        label: 'Source',
        prop: 'sourceStr',
      },
      {
        label: 'Status',
        prop: 'statusStr',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]
    return {
      tableModel,
      searchModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        mark: '',
        name: '',
        status: 1,
        typeId: '',
        num: '',
        source: '',
        firstId: '',
        pid: '',
        onOffshore: '',
      },
      rules: {
        typeId: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        name: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        source: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        onOffshore: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
      optionList: [],
      optionNameList: [],
      isEdit: false,
      isShowShore: false,
    }
  },
  mounted() {
    this._getOptionList()
    this.initTable()
  },
  methods: {
    handleTypeChange(name) {
      if (name === '1396673057358532609') {
        this.isShowShore = true
      } else {
        this.isShowShore = false
      }
    },
    async handleNodeChange(name) {
      if (name === '1396673057358532609') {
        this.isShowShore = true
      } else {
        this.isShowShore = false
      }
      this.form = {
        ...this.form,
        pid: '',
      }
      const _params = {
        typeId: name,
      }
      try {
        const data = await getSelectList(_params)
        this.optionNameList = data.map(option => ({
          id: option.id,
          name: option.name,
        }))
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    async _getOptionList() {
      try {
        const result = await getOptionList()
        this.optionList = result.map(item => ({ name: item.name, id: item.id }))
        this.searchModel[0].selectList = this.optionList
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleClose() {
      this.formId = ''
      this.$refs.form.resetFields()
    },
    async handleSave() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          const submitData = { ...this.form }
          if (this.formId) submitData.id = this.formId
          delete submitData.firstId // 不需要存储firstId
          if (submitData.onOffshore == '') {
            delete submitData.onOffshore
          }

          await this.handleUpdateOrAdd(submitData)
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleUpdateOrAdd(params) {
      try {
        await updateOrAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.isEdit = false
      this.form.typeId = this.$refs.tableList.getSearchData().typeId
      this.visible = true
    },
    async handleEdit(row) {
      // 根据firstId 获取second list options
      const _params = {
        typeId: row.firstId,
      }
      try {
        const data = await getSelectList(_params)
        this.optionNameList = data.map(option => ({
          id: option.id,
          name: option.name,
        }))
        this.visible = true
        this.formId = row.id
        this.isEdit = true
        this.$nextTick(() => {
          Object.keys(this.form).forEach(key => (this.form[key] = row[key]))
        })
      } catch (err) {
        console.error(err)
      }
    },
    async handleRemoveItem(id) {
      try {
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
